(function () {
  // Variant ID do produto add-on de monograma (€15). Ver MONOGRAM_FEATURE.md.
  const ADDON_VARIANT_ID = 57451468915070;
  // Property partilhada entre o produto principal e o seu add-on (guardada verbatim pelo Shopify, com espaço).
  const LINK_PROPERTY = '_Monogram Link';

  // Cinto de segurança anti-reentrância: impede passagens sobrepostas enquanto removemos.
  let isProcessing = false;

  function getLink(item) {
    return item.properties && item.properties[LINK_PROPERTY];
  }

  function isAddon(item) {
    return item.variant_id === ADDON_VARIANT_ID;
  }

  async function reconcile(cart) {
    const items = (cart && cart.items) || [];

    // Links presentes em items PRINCIPAIS (não-addon).
    const mainLinks = new Set();
    items.forEach(function (item) {
      if (!isAddon(item)) {
        const link = getLink(item);
        if (link) mainLinks.add(link);
      }
    });

    // Add-ons órfãos: tripla salvaguarda — (a) é o add-on, (b) tem _Monogram Link, (c) sem principal correspondente.
    const orphans = items.filter(function (item) {
      const link = getLink(item);
      return isAddon(item) && link && !mainLinks.has(link);
    });

    // Add-ons com quantity > 1: cliente forçou via /cart/change.js manual (DevTools/API).
    // A UI já esconde os controlos; isto é o fail-safe — normalizar para 1.
    // Excluímos os órfãos para não colidirem (esses vão a 0 logo abaixo).
    const orphanKeys = new Set(orphans.map(function (o) { return o.key; }));
    const overQuantity = items.filter(function (item) {
      return isAddon(item) && item.quantity > 1 && !orphanKeys.has(item.key);
    });

    for (const orphan of orphans) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: orphan.key, quantity: 0 })
      });
    }

    for (const item of overQuantity) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: item.key, quantity: 1 })
      });
    }

    // O fetch cru não passa pelos componentes do tema, por isso a UI (cart-drawer, contador)
    // não se actualiza sozinha. Os listeners de cart:refresh estão em document; este dispatch
    // força o re-render do tema sem re-acionar o nosso handler (ouvimos cart:change, não cart:refresh).
    if (orphans.length > 0 || overQuantity.length > 0) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }

  document.addEventListener('cart:change', async function (event) {
    // Passivo: só agimos em remoções/alterações de linha, ignoramos outros cart:change.
    if (!event.detail || event.detail.baseEvent !== 'line-item:change') return;
    if (isProcessing) return;

    isProcessing = true;
    try {
      let cart = event.detail.cart;
      if (!cart || !cart.items) {
        const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        cart = await res.json();
      }
      await reconcile(cart);
    } catch (e) {
      console.error('[Monogram cart-sync] reconcile failed:', e);
    } finally {
      isProcessing = false;
    }
  });
})();
